import { render } from "./EventCard.vue?vue&type=template&id=13615fd6&scoped=true&ts=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=13615fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13615fd6"]])

export default __exports__